export default __webpack_public_path__ + "static/avatar-5318a74ce4358e96626769578eaa8a51.jpeg";